import { useSelector } from "react-redux";
import { useThemeDetector } from "./useThemeDetector";

export default function useGetTheme(): "dark" | "light" {
  const systemTheme = useThemeDetector();

  const theme = useSelector((state: any) => state.user.theme);

  if (theme === "system") {
    return systemTheme ? "dark" : "light";
  }
  return theme;
}
